import styled from "styled-components";
import {devices} from '../../../components/MediaQuerys/BreakpointsAndDevices'


export const ConsiderCard = styled.div`
    word-wrap: normal;
    white-space: normal;
    display: grid;
    justify-content: left;
    align-items: start;
    row-gap: 20px;
    width: auto;
    transition: all 1s ease-in-out;
`